var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWorkOfferEmptyState(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 799.468,
    height: 552.327,
    viewBox: "0 0 799.468 552.327",
    role: "img",
    artist: "Katerina Limpitsouni",
    source: "https://undraw.co/",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a-852"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33,0A33,33,0,1,1,0,33,33,33,0,0,1,33,0Z",
    transform: "translate(1533 457)",
    fill: "none",
    stroke: "#0f172a",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b-853"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 33,
    cy: 33,
    r: 33,
    transform: "translate(1533 457)",
    fill: "none",
    stroke: "#0f172a",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c-854"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 32.5,
    cy: 32.5,
    r: 32.5,
    transform: "translate(0 0.277)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-560.266 -263.837)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1352.3,232.384H580.059a13.747,13.747,0,0,0-13.613,13.848v524.66a13.74,13.74,0,0,0,13.613,13.819H1352.3a13.741,13.741,0,0,0,13.613-13.819V246.232a13.747,13.747,0,0,0-13.611-13.848Z",
    transform: "translate(-6.18 31.453)",
    fill: "#0f172a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1328.244,232.384h-748.6a13.225,13.225,0,0,0-13.2,13.223V746.614a13.219,13.219,0,0,0,13.2,13.2h748.6a13.219,13.219,0,0,0,13.2-13.2V245.608a13.224,13.224,0,0,0-13.193-13.223Z",
    transform: "translate(-4.445 34.617)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.137 14.127)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-385.016 11)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M756.062,637.268a64.232,64.232,0,1,0,0,128.463h0a64.232,64.232,0,1,0,0-128.463Z",
    transform: "translate(410.742 -338.268)",
    fill: "#e2e8f0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(14.969 -4.686)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M766.664,264.3a5.588,5.588,0,0,1-3.964-1.643l-44.73-44.732a5.607,5.607,0,1,1,7.929-7.93l44.73,44.732a5.608,5.608,0,0,1-3.965,9.573Z",
    transform: "translate(22.455 142.596)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M721.967,264.3a5.588,5.588,0,0,0,3.965-1.643l44.73-44.732a5.607,5.607,0,1,0-7.929-7.93L718,254.723a5.608,5.608,0,0,0,3.965,9.573Z",
    transform: "translate(22.554 142.596)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-355.168 4.619)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M803.358,374.522H637.953a7.863,7.863,0,0,1-7.854-7.854V142.123a7.863,7.863,0,0,1,7.854-7.854H803.358a7.863,7.863,0,0,1,7.854,7.854V366.667a7.863,7.863,0,0,1-7.854,7.854Z",
    transform: "translate(432.807 368.732)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M803.358,374.522H637.953a7.863,7.863,0,0,1-7.854-7.854V142.123a7.863,7.863,0,0,1,7.854-7.854H803.358a7.863,7.863,0,0,1,7.854,7.854V366.667a7.863,7.863,0,0,1-7.854,7.854ZM637.953,135.193a6.938,6.938,0,0,0-6.93,6.93V366.667a6.938,6.938,0,0,0,6.93,6.93H803.358a6.938,6.938,0,0,0,6.93-6.93V142.123a6.938,6.938,0,0,0-6.93-6.93Z",
    transform: "translate(432.807 368.732)",
    fill: "#cbd5e1"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-365.168 -5.381)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M803.358,374.522H637.953a7.863,7.863,0,0,1-7.854-7.854V142.123a7.863,7.863,0,0,1,7.854-7.854H803.358a7.863,7.863,0,0,1,7.854,7.854V366.667a7.863,7.863,0,0,1-7.854,7.854Z",
    transform: "translate(432.807 368.732)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M803.358,374.522H637.953a7.863,7.863,0,0,1-7.854-7.854V142.123a7.863,7.863,0,0,1,7.854-7.854H803.358a7.863,7.863,0,0,1,7.854,7.854V366.667a7.863,7.863,0,0,1-7.854,7.854ZM637.953,135.193a6.938,6.938,0,0,0-6.93,6.93V366.667a6.938,6.938,0,0,0,6.93,6.93H803.358a6.938,6.938,0,0,0,6.93-6.93V142.123a6.938,6.938,0,0,0-6.93-6.93Z",
    transform: "translate(432.807 368.732)",
    fill: "#cbd5e1"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-56.098 323.34)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M635.048,554.8H462.578a8.2,8.2,0,0,1-8.19-8.19V312.475a8.2,8.2,0,0,1,8.19-8.19H635.048a8.2,8.2,0,0,1,8.19,8.19V546.611a8.2,8.2,0,0,1-8.19,8.19Z",
    transform: "translate(280.711 -150.268)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.593,508.04H495.044a3.861,3.861,0,1,1,0-7.722H616.593a3.861,3.861,0,0,1,0,7.722Z",
    transform: "translate(265.707 -230.205)",
    fill: "#f1f5f9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M632.519,530.043H495.044a3.861,3.861,0,1,1,0-7.722H632.519a3.861,3.861,0,0,1,0,7.722Z",
    transform: "translate(265.707 -239.177)",
    fill: "#f1f5f9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.593,580.613H495.044a3.861,3.861,0,0,1,0-7.722H616.593a3.861,3.861,0,1,1,0,7.722Z",
    transform: "translate(265.707 -259.798)",
    fill: "#f1f5f9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M632.519,602.616H495.044a3.861,3.861,0,0,1,0-7.722H632.519a3.861,3.861,0,1,1,0,7.722Z",
    transform: "translate(265.707 -268.77)",
    fill: "#f1f5f9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.593,653.186H495.044a3.861,3.861,0,1,1,0-7.722H616.593a3.861,3.861,0,0,1,0,7.722Z",
    transform: "translate(265.707 -289.392)",
    fill: "#f1f5f9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M632.519,675.189H495.044a3.861,3.861,0,0,1,0-7.722H632.519a3.861,3.861,0,0,1,0,7.722Z",
    transform: "translate(265.707 -298.364)",
    fill: "#f1f5f9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.506,384.006a31.937,31.937,0,0,0,9.418,22.688c.251.247.507.5.766.737a31.991,31.991,0,0,0,5.085,3.876c.349.216.7.422,1.057.623a31.85,31.85,0,0,0,5.789,2.542c.347.114.7.221,1.051.32a32.165,32.165,0,0,0,19.459-.547l.364-.131a32.036,32.036,0,1,0-42.989-30.108Z",
    transform: "translate(265.167 -169.712)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M666.8,401.649H618a3.861,3.861,0,0,1,0-7.722h48.8a3.861,3.861,0,1,1,0,7.722Z",
    transform: "translate(215.569 -186.821)",
    fill: "#f1f5f9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M682.728,423.651H618a3.861,3.861,0,0,1,0-7.722h64.729a3.861,3.861,0,1,1,0,7.722Z",
    transform: "translate(215.569 -195.793)",
    fill: "#f1f5f9"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M635.048,554.8H462.578a8.2,8.2,0,0,1-8.19-8.19V312.475a8.2,8.2,0,0,1,8.19-8.19H635.048a8.2,8.2,0,0,1,8.19,8.19V546.611a8.2,8.2,0,0,1-8.19,8.19ZM462.578,305.249a7.235,7.235,0,0,0-7.226,7.226V546.611a7.235,7.235,0,0,0,7.226,7.226H635.048a7.235,7.235,0,0,0,7.226-7.226V312.475a7.235,7.235,0,0,0-7.226-7.226Z",
    transform: "translate(224.613 173.072)",
    fill: "#1e293b"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-832.863 48.127)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a-852)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 10.004,
    cy: 10.005,
    rx: 10.004,
    ry: 10.005,
    transform: "matrix(0.978, 0.208, -0.208, 0.978, 1559.506, 475.285)",
    fill: "#fecaca"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.372,462.9l17.008-3.336c-2.191-4.673-3.945-6.253-2-11.339H302.706C303.909,453.5,302.746,458.441,301.372,462.9Z",
    transform: "matrix(0.978, 0.208, -0.208, 0.978, 1358.66, -11.672)",
    fill: "#fecaca"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.536,539.208l40.018-11.339c-8.016-17.642-9.693-37.012-7.318-57.485a3.7,3.7,0,0,0-3.249-4.11l-.135-.013c-5.22-.43-10.662-.982-16.31-1.753l-6.336,4.335-7.337-1.668c-2.354,1.141-4.725,2.09-6.866,3.036a8.583,8.583,0,0,0-4.666,10.556C252.857,500.46,257.222,519.966,258.536,539.208Z",
    transform: "matrix(0.978, 0.208, -0.208, 0.978, 1404.375, -11.094)",
    fill: "#f1f5f9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.924,526.434l7.67-1-18.169-52.356c-.924-2.663-3.216-4.1-6.007-4.5l-2.668.334,2,31.014Z",
    transform: "matrix(0.978, 0.208, -0.208, 0.978, 1465.775, -0.326)",
    fill: "#f1f5f9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.719,522.315h0a6.079,6.079,0,0,0,6.08-3.729l7.313-17.609-6-21.676-1.587,1.01q-.229.146-.451.3a14.271,14.271,0,0,0-5.861,14.189l1.565,9.18-6.458,13.865a6.079,6.079,0,0,0,5.4,4.472Z",
    transform: "matrix(0.978, 0.208, -0.208, 0.978, 1303.77, -40.783)",
    fill: "#f1f5f9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.131,407.191h0a11.885,11.885,0,0,0-4.854,1.235c-.34.171-.183.788-.5.989-.4.253-1.256.1-1.606.4a8.533,8.533,0,0,0-3.166,7.413l.558,4.8,1.317-1.244a14.631,14.631,0,0,1,9.155-3.884q.225-.013.451-.021l-1.013-1.533,1.761,1.522a19.791,19.791,0,0,1,2.4.169l-1.347-2.037,2.585,2.234h0a6.782,6.782,0,0,1,4.83,3.4l.287.55.321-4.576c.128-5.095-4.546-9.311-10.439-9.423Q312.5,407.176,312.131,407.191Z",
    transform: "matrix(0.978, 0.208, -0.208, 0.978, 1348.711, 9.26)",
    fill: "#0f172a"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M33,1A32.009,32.009,0,0,0,20.544,62.486,32.009,32.009,0,0,0,45.456,3.514,31.8,31.8,0,0,0,33,1m0-1A33,33,0,1,1,0,33,33,33,0,0,1,33,0Z",
    transform: "translate(1533 457)",
    fill: "#f1f5f9"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-53.877 25.127)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M756.062,637.268a64.232,64.232,0,1,0,0,128.463h0a64.232,64.232,0,1,0,0-128.463Z",
    transform: "translate(410.742 -338.268)",
    fill: "#234ba2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M749.968,728.176a7.8,7.8,0,0,1-4.69-1.559l-.084-.063L727.53,713.042a7.85,7.85,0,1,1,9.552-12.459l11.441,8.774,27.036-35.271a7.846,7.846,0,0,1,11-1.453h0l0,0-.168.233.172-.233a7.856,7.856,0,0,1,1.451,11l-31.8,41.468a7.85,7.85,0,0,1-6.244,3.061Z",
    transform: "translate(410.742 -338.268)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.137 14.127)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-37.305 -9.508)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M803.358,374.522H637.953a7.863,7.863,0,0,1-7.854-7.854V142.123a7.863,7.863,0,0,1,7.854-7.854H803.358a7.863,7.863,0,0,1,7.854,7.854V366.667a7.863,7.863,0,0,1-7.854,7.854Z",
    transform: "translate(432.807 368.732)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M803.358,374.522H637.953a7.863,7.863,0,0,1-7.854-7.854V142.123a7.863,7.863,0,0,1,7.854-7.854H803.358a7.863,7.863,0,0,1,7.854,7.854V366.667a7.863,7.863,0,0,1-7.854,7.854ZM637.953,135.193a6.938,6.938,0,0,0-6.93,6.93V366.667a6.938,6.938,0,0,0,6.93,6.93H803.358a6.938,6.938,0,0,0,6.93-6.93V142.123a6.938,6.938,0,0,0-6.93-6.93Z",
    transform: "translate(432.807 368.732)",
    fill: "#cbd5e1"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-47.305 -19.508)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M803.358,374.522H637.953a7.863,7.863,0,0,1-7.854-7.854V142.123a7.863,7.863,0,0,1,7.854-7.854H803.358a7.863,7.863,0,0,1,7.854,7.854V366.667a7.863,7.863,0,0,1-7.854,7.854Z",
    transform: "translate(432.807 368.732)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M803.358,374.522H637.953a7.863,7.863,0,0,1-7.854-7.854V142.123a7.863,7.863,0,0,1,7.854-7.854H803.358a7.863,7.863,0,0,1,7.854,7.854V366.667a7.863,7.863,0,0,1-7.854,7.854ZM637.953,135.193a6.938,6.938,0,0,0-6.93,6.93V366.667a6.938,6.938,0,0,0,6.93,6.93H803.358a6.938,6.938,0,0,0,6.93-6.93V142.123a6.938,6.938,0,0,0-6.93-6.93Z",
    transform: "translate(432.807 368.732)",
    fill: "#cbd5e1"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(261.766 309.213)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M635.048,554.8H462.578a8.2,8.2,0,0,1-8.19-8.19V312.475a8.2,8.2,0,0,1,8.19-8.19H635.048a8.2,8.2,0,0,1,8.19,8.19V546.611a8.2,8.2,0,0,1-8.19,8.19Z",
    transform: "translate(280.711 -150.268)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.593,508.04H495.044a3.861,3.861,0,1,1,0-7.722H616.593a3.861,3.861,0,0,1,0,7.722Z",
    transform: "translate(265.707 -230.205)",
    fill: "#234ba2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M632.519,530.043H495.044a3.861,3.861,0,1,1,0-7.722H632.519a3.861,3.861,0,0,1,0,7.722Z",
    transform: "translate(265.707 -239.177)",
    fill: "#234ba2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.593,580.613H495.044a3.861,3.861,0,0,1,0-7.722H616.593a3.861,3.861,0,1,1,0,7.722Z",
    transform: "translate(265.707 -259.798)",
    fill: "#234ba2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M632.519,602.616H495.044a3.861,3.861,0,0,1,0-7.722H632.519a3.861,3.861,0,1,1,0,7.722Z",
    transform: "translate(265.707 -268.77)",
    fill: "#234ba2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.593,653.186H495.044a3.861,3.861,0,1,1,0-7.722H616.593a3.861,3.861,0,0,1,0,7.722Z",
    transform: "translate(265.707 -289.392)",
    fill: "#234ba2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M632.519,675.189H495.044a3.861,3.861,0,0,1,0-7.722H632.519a3.861,3.861,0,0,1,0,7.722Z",
    transform: "translate(265.707 -298.364)",
    fill: "#234ba2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.506,384.006a31.937,31.937,0,0,0,9.418,22.688c.251.247.507.5.766.737a31.991,31.991,0,0,0,5.085,3.876c.349.216.7.422,1.057.623a31.85,31.85,0,0,0,5.789,2.542c.347.114.7.221,1.051.32a32.165,32.165,0,0,0,19.459-.547l.364-.131a32.036,32.036,0,1,0-42.989-30.108Z",
    transform: "translate(265.167 -169.712)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M666.8,401.649H618a3.861,3.861,0,0,1,0-7.722h48.8a3.861,3.861,0,1,1,0,7.722Z",
    transform: "translate(215.569 -186.821)",
    fill: "#234ba2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M682.728,423.651H618a3.861,3.861,0,0,1,0-7.722h64.729a3.861,3.861,0,1,1,0,7.722Z",
    transform: "translate(215.569 -195.793)",
    fill: "#234ba2"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M635.048,554.8H462.578a8.2,8.2,0,0,1-8.19-8.19V312.475a8.2,8.2,0,0,1,8.19-8.19H635.048a8.2,8.2,0,0,1,8.19,8.19V546.611a8.2,8.2,0,0,1-8.19,8.19ZM462.578,305.249a7.235,7.235,0,0,0-7.226,7.226V546.611a7.235,7.235,0,0,0,7.226,7.226H635.048a7.235,7.235,0,0,0,7.226-7.226V312.475a7.235,7.235,0,0,0-7.226-7.226Z",
    transform: "translate(542.477 158.945)",
    fill: "#1e293b"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-517 34)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b-853)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(894 239.723)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(640 220)",
    clipPath: "url(#c-854)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(12.499 15.421)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M466.225,67.913a8.8,8.8,0,1,0-13.4,4.676l-5.374,13.47,26.4-2.237s-13.373-7.18-13.544-10.048A8.794,8.794,0,0,0,466.225,67.913Z",
    transform: "translate(-436.719 -50.756)",
    fill: "#fecaca"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M692.827,283.36l2.045-.945a3.85,3.85,0,0,1,3.033,2.933c.7,2.635,3.878,16.754,3.878,16.754a4.094,4.094,0,0,1,.8,4.375s.372,2.809-.8,3.232-8.989,6.461-8.989,6.461l.034-32.81Z",
    transform: "translate(-657.007 -253.573)",
    fill: "#234ba2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.362,228.309,397.4,225.2c-1.219,6.065-6.835,6.288-8.054.224l-3.887,2.885-8.2,2.734,1.193,31.805,16.65-.048v.048h15.266l1.193-31.805Z",
    transform: "translate(-373.699 -202.201)",
    fill: "#234ba2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.993,283.36l-2.045-.945a3.85,3.85,0,0,0-3.033,2.933c-.7,2.635.6,17.872.6,17.872a4.094,4.094,0,0,0-.8,4.375s-.372,2.809.8,3.232a25.042,25.042,0,0,0,4.481.61V283.36Z",
    transform: "translate(-342.386 -253.573)",
    fill: "#234ba2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.7,10.374l-.607,6.192s-6.369-12.358,1.552-14.643c0,0-.771-1.044.348-1.392s11.732-2.014,12.578,3.182c0,0,5.544,3.436,3.866,7.112l-1.977,4.322-1.79.1s-.05-8.228-2.784-7.954S449.7,10.374,449.7,10.374Z",
    transform: "translate(-436.022 0)",
    fill: "#0f172a"
  }))))), /*#__PURE__*/React.createElement("path", {
    d: "M33,1A32.009,32.009,0,0,0,20.544,62.486,32.009,32.009,0,0,0,45.456,3.514,31.8,31.8,0,0,0,33,1m0-1A33,33,0,1,1,0,33,33,33,0,0,1,33,0Z",
    transform: "translate(1533 457)",
    fill: "#0f172a"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkOfferEmptyState);
export default __webpack_public_path__ + "static/media/workOffer-empty-state.94a5d86a83f7003efdacbea2a7ee8fb4.svg";
export { ForwardRef as ReactComponent };